import { useEffect } from 'react';
import useTableSounds from '../../hooks/useTableSounds';
import { EventSounds } from '@/services/table/tableTypes';
import { useSelector } from 'react-redux';
import {
  selectHandState,
  selectIsActingPlayer,
  // selectIsWinner,
  selectTableSounds,
  selectTableStateUndefined,
} from '../../../../services/table/tableSelectors';

interface TableSoundsProps {
  tableId: string;
}

const TableSounds = ({ tableId }: TableSoundsProps) => {
  const {
    playFirstWarning,
    playSecondWarning,
    playDeal,
    playBoardDeal,
    playChipsGoingToPot,
    playChipsPullingToPot,
    playChipsMany,
    playChipsFalling,
    playBet,
    playFolding,
    playCall,
    playCheck,
    // playWin,
    // playLose,
    playTurnRiverDeal,
  } = useTableSounds();

  const tableSounds = useSelector(selectTableSounds(tableId));
  const isActingPlayer = useSelector(selectIsActingPlayer(tableId));
  // TODO: Check why this is relevant for sounds, since at the end of the hand this state changes and it runs the effect twice, making chip pulling sound run twice
  // const isWinner = useSelector(selectIsWinner(tableId));
  const tableStateIsUndefined = useSelector(selectTableStateUndefined(tableId));
  const handState = useSelector(selectHandState(tableId));

  useEffect(() => {
    if (tableStateIsUndefined || !handState) {
      return;
    }

    switch (tableSounds) {
      case EventSounds.DEAL:
        playDeal();
        break;
      case EventSounds.FLOP:
        playBoardDeal();
        playChipsFalling();
        break;
      case EventSounds.BOARD_DEAL:
        playTurnRiverDeal();
        break;
      case EventSounds.CHIPS_PUSHING:
        playChipsGoingToPot();
        break;
      case EventSounds.CHIPS_PULLING:
        playChipsPullingToPot();
        break;
      case EventSounds.RAISE:
        playChipsMany();
        break;
      case EventSounds.BET:
        playBet();
        break;
      case EventSounds.FOLD:
        playFolding();
        break;
      case EventSounds.CALL:
        playCall();
        break;
      case EventSounds.CHECK:
        playCheck();
        break;
    }
  }, [tableSounds]);
  useEffect(() => {
    if (tableStateIsUndefined || !handState) {
      return;
    }

    switch (tableSounds) {
      case EventSounds.FIRST_WARNING:
        if (isActingPlayer) playFirstWarning();
        break;
      case EventSounds.SECOND_WARNING:
        if (isActingPlayer) playSecondWarning();
        break;
    }
  }, [tableSounds, isActingPlayer]);

  return <></>;
};

export default TableSounds;
